import React, { useState } from "react";
import { Label } from "reactstrap";
import { isBiro } from "../utils/helper";
import { Select, Button, Input } from "semantic-ui-react";
import axiosInstance from "../utils/API";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import LoadingTop from "../component/LoadingTop";

const Financial = () => {
  const [perusahaan, setPerusahaan] = useState([]);
  const [years, setYears] = useState([]);
  const date = new Date();
  const [year, setYear] = useState(date.getFullYear());
  const [perusahaanId, setPerusahaanId] = useState(null);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [data, setData] = useState({});
  const [tableHeaders, setTableHeaders] = useState([]);
  const [fields, setFields] = useState([]);
  const [months, setMonths] = useState([]);
  const [fieldParents, setFieldParents] = useState([]);
  const [loadingPerusahaan, setLoadingPerusahaan] = useState(false);
  const [loadingYear, setLoadingYear] = useState(false);
  const [isKomisaris, setIsKomisaris] = useState(null);
  const u = localStorage.getItem("user");
  const user = JSON.parse(u);
  const [dataExist, setDataExist] = useState(false);
  const [namaPerusahaan, setNamaPerusahaan] = useState([]);



  const loadData = async () => {
    if (user.role * 1 === 4) {
      setPerusahaanId(user.perusahaan.id);
      setIsKomisaris(true);
      handlePreview(user.perusahaan.id, year);
    } else {
      const res = await axiosInstance.get("/perusahaan?search=nama:**&size=300");
      const d = res.data.content
      .sort((a, b) => a.nama > b.nama ? 1 : -1)
      .map((r) => ({ value: r.id, text: r.nama }));
      // d.unshift({ value: "all", text: "Semua Non Lembaga Keuangan" });
      setPerusahaan(d);
      handlePreview(null, year);
    }
    let y = [];
    for (let i = 2016; i < year; i++) {
      y.push({ value: i + 1, text: i + 1 });
    }
    setYears(y);
  };

  const realisasiQuartal = (j, f) => {
    if (f !== "") {
      const first = (j * 2 - 6) / 2;
      const second = (j * 2 - 4) / 2;
      const third = (j * 2 - 2) / 2;
      let val = 0;
      val += data[`${tableHeaders[first].toLowerCase()}-${f.toLowerCase()}`] ?? 0;
      val += data[`${tableHeaders[second].toLowerCase()}-${f.toLowerCase()}`] ?? 0;
      val += data[`${tableHeaders[third].toLowerCase()}-${f.toLowerCase()}`] ?? 0;
      return val;
    }
  };

  const anggaranQuartal = (j, f) => {
    if (f !== "") {
      const first = (j * 2 - 6) / 2;
      const second = (j * 2 - 4) / 2;
      const third = (j * 2 - 2) / 2;
      let val = 0;
      val += data[`${tableHeaders[first].toLowerCase()}-rkap-${f.toLowerCase()}`] ?? 0;
      val += data[`${tableHeaders[second].toLowerCase()}-rkap-${f.toLowerCase()}`] ?? 0;
      val += data[`${tableHeaders[third].toLowerCase()}-rkap-${f.toLowerCase()}`] ?? 0;
      return val;
    }
  };

  const FormatNumber = (data) => {
    if (data == null) return data;
    return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handlePreview = async (perusahaanId, year) => {
    if (perusahaanId) {
      try {
        let url = `/excel/preview?year=${year}`;
        if (perusahaanId !== "all") url += `&perusahaanId=${perusahaanId}`;
        const res = await axiosInstance.get(url, { responseType: "json" });
        if (Object.keys(res.data.data).length === 0) {
          toast.error("Data tidak ada!", { position: toast.POSITION.BOTTOM_RIGHT });
          setData({});
          setTableHeaders([]);
          setMonths([]);
          setFields([]);
          setFieldParents([]);
          setDataExist(false);
        } else {
          setData(res.data.data);
          setTableHeaders(res.data.tableHeaders);
          setMonths(res.data.months);
          setFields(res.data.fields);
          setNamaPerusahaan(res.data.namaPerusahaan);
          setFieldParents(res.data.fieldParents);
          setDataExist(true);
        }
      } catch (err) {
        toast.error(err.message, { position: toast.POSITION.BOTTOM_RIGHT });
      }
    }
  };

  const changePerusahaan = async (v) => {
    setPerusahaanId(v);
    setLoadingPerusahaan(true);
    await handlePreview(v, year);
    setLoadingPerusahaan(false);
  };

  const changeYear = async (v) => {
    setYear(v);
    setLoadingYear(true);
    await handlePreview(perusahaanId, v);
    setLoadingYear(false);
  };

  const handleDownload = async () => {
    setLoadingBtn(true);
    let url = `/excel?year=${year}`;
    if (perusahaanId !== "all") url += `&perusahaanId=${perusahaanId}`;
    axiosInstance
      .get(url, { responseType: "blob" })
      .then((res) => {
        fileDownload(res.data, `${namaPerusahaan} Standar Akun Simolek v.1.4 - Form Tahunan ${year}.xlsx`);
      })
      .catch((res) => toast.error(res.message))
      .finally(() => {
        setLoadingBtn(false);
      });
  };
  

  // const handleDownload = async () => {

  //   let url = `/excel?year=${year}&perusahaanId=${perusahaanId}`;
  //   const result = await axiosInstance.get(url, { responseType: "blob" })
  //   // axiosInstance.get(url, {
  //   //   responseType: 'blob',
  //   // })
  //   .then((res) => {
  //     fileDownload(res.data, `SIMOLEK-Form - ${namaPerusahaan}- ${year}.xlsx`);
  //   })
  //   .catch((res) => toast.error(res.message))
  //     .finally(() => {
  //       setLoadingBtn(false);
  //     });
  // }

  const show = (d) => {
    if (d === 0) return <>&nbsp;</>;
    return FormatNumber(d);
  };

  const ytdRealisasi = (f) => {
    let sum = 0;
    for (let i = 0; i < months.length; i++) {
      sum += data[`${months[i].toLowerCase()}-${f.toLowerCase()}`] ?? 0;
    }
    return sum;
  };

  const ytdAnggaran = (f) => {
    let sum = 0;
    for (let i = 0; i < months.length; i++) {
      sum += data[`${months[i].toLowerCase()}-rkap-${f.toLowerCase()}`] ?? 0;
    }
    return sum;
  };

  React.useEffect(() => {
    loadData();
    handlePreview(perusahaanId, year);
  }, []);
  return (
    <div className="container mt-3">
      <LoadingTop />
      <div className="card border-0 rounded-0">
        <div className="container py-4">
          <div className="row px-4">
            <div className="col-md-3 d-flex align-items-center">
              <h3 className="mr-auto my-auto">Ringkasan Keuangan</h3>
            </div>
            <div className="col-md-5 d-flex justify-content-start align-items-center">
              {isBiro() && (
                <>
                  <Label className="mr-3">Perusahaan</Label>
                  {loadingPerusahaan ? (
                    <Input disabled loading placeholder="Loading..." />
                  ) : (
                    <Select
                      className={`input--perusahaan`}
                      onChange={(e, { value }) => changePerusahaan(value)}
                      options={perusahaan}
                      value={perusahaanId}
                      search
                      placeholder="Pilih Perusahaan Induk"
                    />
                  )}
                </>
              )}
              {isKomisaris && <p style={{ fontSize: 16 }}>{user.perusahaan.nama}</p>}
            </div>
            <div className="col-md-2 d-flex justify-content-end align-items-center mt-md-0 mt-3">
              <Label className="mr-3">Tahun</Label>
              {loadingYear ? (
                <Input disabled loading placeholder="Loading..." />
              ) : (
                <Select
                  className={`input--years`}
                  value={year}
                  onChange={(e, { value }) => changeYear(value)}
                  options={years}
                />
              )}
            </div>
            <div className="col-md-2 d-flex justify-content-start align-items-center mt-md-0 mt-3">
              <Button onClick={handleDownload} color="blue" loading={loadingBtn} disabled={!dataExist}>
                Download Excel
              </Button>
            </div>
          </div>
        </div>
      </div>
      {Object.keys(data).length > 1 && (
        <div className="card border-0 rounded-0">
          <div className="container py-4">
            <div className="row px-4">
              <div className="col-md-5 pr-0">
                <div className="table-responsive table-fixed">
                  <table className="table fixed table-bordered">
                    <thead>
                      <tr>
                        {tableHeaders.map(
                          (m, i) =>
                            i === 0 && (
                              <th rowSpan="2" align="center" style={{ verticalAlign: "middle" }}>
                                <p style={{ textAlign: "center", width: 300, height: 61, lineHeight: "61px" }}>{m}</p>
                              </th>
                            )
                        )}
                      </tr>
                      <tr>
                        {/* {tableHeaders.map(
                        (m, i) =>
                          i !== 0 && (
                            <>
                              <th align="center">
                                <p style={{ textAlign: "center", width: 200 }}>Realisasi</p>
                              </th>
                              <th align="center">
                                <p style={{ textAlign: "center", width: 200 }}>Anggaran</p>
                              </th>
                            </>
                          )
                      )} */}
                      </tr>
                    </thead>
                    {fields.map((f, i) => (
                      <tr key={i} style={i % 2 !== 1 ? { backgroundColor: "#f8f9fa" } : {}}>
                        <td>{f === "" ? <>&nbsp;</> : fieldParents.includes(f) ? <b>{f}</b> : f}</td>
                      </tr>
                    ))}
                  </table>  
                </div>
              </div>
              <div className="col-md-7 pl-0">
                <div className="table-responsive table-fixed">
                  <table className="table fixed table-bordered">
                    <thead>
                      <tr>
                        {tableHeaders.map(
                          (m, i) =>
                            i > 0 && (
                              <th colSpan="2" align="center" key={m}>
                                <p style={{ textAlign: "center" }}>{m}</p>
                              </th>
                            )
                        )}
                      </tr>
                      <tr>
                        {tableHeaders.map(
                          (m, i) =>
                            i !== 0 && (
                              <>
                                <th align="center">
                                  <p style={{ textAlign: "center", width: 200 }}>Realisasi</p>
                                </th>
                                <th align="center">
                                  <p style={{ textAlign: "center", width: 200 }}>Anggaran</p>
                                </th>
                              </>
                            )
                        )}
                      </tr>
                    </thead>
                    {fields.map((f, i) => (
                      <tr key={i} style={i % 2 !== 1 ? { backgroundColor: "#f8f9fa" } : {}}>
                        {tableHeaders.map((th, j) =>
                          j !== 0 ? (
                            !fieldParents.includes(f) ? (
                              th === tableHeaders[tableHeaders.length - 1] ? (
                                f === "" ? (
                                  <>
                                    <td align="right">&nbsp;</td>
                                    <td align="right">&nbsp;</td>
                                  </>
                                ) : (
                                  <>
                                    <td align="right">{show(ytdRealisasi(f))}</td>
                                    <td align="right">{show(ytdAnggaran(f))}</td>
                                  </>
                                )
                              ) : !th.includes("Q") ? (
                                <>
                                  <td align="right">{show(data[`${th.toLowerCase()}-${f.toLowerCase()}`])}</td>
                                  <td align="right">{show(data[`${th.toLowerCase()}-rkap-${f.toLowerCase()}`])}</td>
                                </>
                              ) : (
                                <>
                                  <td align="right">{show(realisasiQuartal(j, f))}</td>
                                  <td align="right">{show(anggaranQuartal(j, f))}</td>
                                </>
                              )
                            ) : (
                              <>
                                <td align="right">&nbsp;</td>
                                <td align="right">&nbsp;</td>
                              </>
                            )
                          ) : null
                        )}
                      </tr>
                    ))}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Financial;
